module.exports = __webpack_public_path__ + "img/full7-min.996f8607.png";